import { render, staticRenderFns } from "./ThreadComment.vue?vue&type=template&id=45a33d73&"
import script from "./ThreadComment.vue?vue&type=script&lang=js&"
export * from "./ThreadComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports